'use strict';
var novicell = novicell || {};

novicell.filterVideos = novicell.filterVideos || function () {

    function init() {
        let post_wrapper = document.querySelectorAll('.js-load-more-wrapper');

        if ( post_wrapper ) {
            reset_filters(post_wrapper);
            set_active_filters(post_wrapper);
            set_active_filters_count();
            filter_video(post_wrapper);

            let js_filters = document.querySelectorAll('.js-filters');
            js_filters.forEach(filter => {

                filter.addEventListener('change', function(e) {
                    let filter_toggles = document.querySelectorAll('[name="' + e.target.getAttribute('name') + '"');

                    if ( e.target.checked == false ) {
                        filter_toggles.forEach(toggle => {
                            if ( toggle.value == e.target.value ) {
                                toggle.checked = false;
                            }
                        })
                    } else {
                        filter_toggles.forEach(toggle => {
                            if ( toggle.value == e.target.value ) {
                                toggle.checked = true;
                            }
                        })
                    }

                    filter_video(post_wrapper);
                });

            });
        }
    }

    function reset_filters(post_wrapper) {
        const reset_toggles = document.querySelectorAll('.filter-overlay-header__reset');

        reset_toggles.forEach(toggle => {
            toggle.addEventListener('click', function() {
                let js_filters = document.querySelectorAll('.js-filters');

                js_filters.forEach(checkbox => {
                    checkbox.checked = false;
                });

                set_locale_storage('', '', '', '', '', '', '');

                set_active_filters_count();
                filter_video(post_wrapper);
            });
        });
    }

    function set_locale_storage(level, tools, interval, focus, type, subtype, special, trainer, duration) {
        localStorage.setItem("level", JSON.stringify(level));
        localStorage.setItem("tools", JSON.stringify(tools));
        localStorage.setItem("interval", JSON.stringify(interval));
        localStorage.setItem("focus", JSON.stringify(focus));
        localStorage.setItem("type", JSON.stringify(type));
        localStorage.setItem("subtype", JSON.stringify(subtype));
        localStorage.setItem("special", JSON.stringify(special));
        localStorage.setItem("trainer", JSON.stringify(trainer));
        localStorage.setItem("duration", JSON.stringify(duration));
    }

    function removeDuplicates(array) {
        return array.filter((a, b) => array.indexOf(a) === b)
    };

    function set_active_filters(post_wrapper) {

        let level       = JSON.parse(localStorage.getItem('level')),
            tools       = JSON.parse(localStorage.getItem('tools')),
            interval    = JSON.parse(localStorage.getItem('interval')),
            focus       = JSON.parse(localStorage.getItem('focus')),
            type        = JSON.parse(localStorage.getItem('type')),
            subtype     = JSON.parse(localStorage.getItem('subtype')),
            special     = JSON.parse(localStorage.getItem('special')),
            trainer     = JSON.parse(localStorage.getItem('trainer')),
            duration     = JSON.parse(localStorage.getItem('duration'));

        let filterBoxes = document.querySelectorAll('.js-filters');

        filterBoxes.forEach(boxes => {

            if (    level && level.includes(boxes.value) ||
                    tools && tools.includes(boxes.value) ||
                    interval && interval.includes(boxes.value) ||
                    focus && focus.includes(boxes.value) ||
                    type && type.includes(boxes.value) ||
                    subtype && subtype.includes(boxes.value) ||
                    special && special.includes(boxes.value) ||
                    trainer && trainer.includes(boxes.value) ||
                    duration && duration.includes(boxes.value))
            {
                boxes.checked = true;
            }

        });

        filter_video(post_wrapper);

    }

    function set_active_filters_count() {

        let filter_counter = document.querySelectorAll('.filter-item__active');

        filter_counter.forEach(counter => {
            let active_filters          = counter.getAttribute('data-filter'),
                selected_filters_count  = document.querySelectorAll('[name="' + active_filters + '"]:checked').length;

            if ( selected_filters_count > 0 ) {
                counter.innerHTML = '(' + selected_filters_count / 2 + ')';
            } else {
                counter.innerHTML = '';
            }
        });
    }

    function filter_video(lists) {
        let action = 'filter_videos';

        lists.forEach(list => {
            let posts_list      = list.querySelector('.js-load-more-list'),
                filter_level    = list.querySelectorAll('[name="filter-level[]"]'),
                filter_tools    = list.querySelectorAll('[name="filter-tools[]"]'),
                filter_interval = list.querySelectorAll('[name="filter-interval[]"]'),
                filter_focus    = list.querySelectorAll('[name="filter-focus[]"]'),
                filter_type     = list.querySelectorAll('[name="filter-type[]"]'),
                filter_subtype  = list.querySelectorAll('[name="filter-subtype[]"]'),
                filter_trainer  = list.querySelectorAll('[name="filter-trainer[]"]'),
                filter_special  = list.querySelectorAll('[name="filter-special[]"]'),
                filter_duration  = list.querySelectorAll('[name="filter-duration[]"]'),
                category        = nh_ajax_object.category,
                load_more_btn   = list.querySelector('.js-load-more-btn');

            let level       = removeDuplicates([].filter.call(filter_level, (c) => c.checked).map(c => c.value)),
                tools       = removeDuplicates([].filter.call(filter_tools, (c) => c.checked).map(c => c.value)),
                interval    = removeDuplicates([].filter.call(filter_interval, (c) => c.checked).map(c => c.value)),
                focus       = removeDuplicates([].filter.call(filter_focus, (c) => c.checked).map(c => c.value)),
                type        = removeDuplicates([].filter.call(filter_type, (c) => c.checked).map(c => c.value)),
                subtype     = removeDuplicates([].filter.call(filter_subtype, (c) => c.checked).map(c => c.value)),
                special     = removeDuplicates([].filter.call(filter_special, (c) => c.checked).map(c => c.value)),
                trainer     = removeDuplicates([].filter.call(filter_trainer, (c) => c.checked).map(c => c.value)),
                duration     = removeDuplicates([].filter.call(filter_duration, (c) => c.checked).map(c => c.value));

            let btn         = load_more_btn;

            set_active_filters_count();
            set_locale_storage(level, tools, interval, focus, type, subtype, special, trainer, duration);

            filterVideosRequest(action, level, tools, interval, focus, type, subtype, special, trainer, duration, category, btn, posts_list);
        });
    }

    function filterVideosRequest(action, level, tools, interval, focus, type, subtype, special, trainer, duration, category, btn, posts_list) {

        var request = new XMLHttpRequest(),
            method  = 'POST',
            url     = ajaxurl;

        request.open(method, url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');

        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                posts_list.innerHTML = "";
                // If successful
                let posts       = posts_list.innerHTML;

                let data = JSON.parse(this.responseText);

                posts += data.content;

                nh_ajax_object.current_page = 1;
				nh_ajax_object.posts = data.posts;
                nh_ajax_object.max_page = data.max_page;
                nh_ajax_object.filtered = 'true';

                posts_list.innerHTML = posts;

                var countEl = document.querySelectorAll('.workouts-post-count');

                countEl.forEach(counter => {
                    counter.innerHTML = data.found_posts
                });

                if ( nh_ajax_object.current_page < nh_ajax_object.max_page ) {
                    btn.style.display = 'block';
                    btn.innerHTML = 'Se flere';
                } else {
                    btn.style.display = 'none';
                }

                // Set image watcher on newly added posts
                novicell.lazyLoader.lazy_load(posts_list);
            } else {
                // If fail
                console.log(this.response);
            }
        };

        request.onerror = function() {
            console.log("Request failed");
        };

        request.send('action=' + action + '&level=' + level + '&tools=' + tools + '&interval=' + interval + '&focus=' + focus + '&type=' + type + '&subtype=' + subtype +  '&special=' + special + '&trainer=' + trainer + '&duration=' + duration +'&category=' + category);
    }

    return {
        init : init
    };

}();
